import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { SERVICES } from "@/mock";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "../ui/carousel";

const chunk = (arr, size) =>
    arr.length ? [arr.slice(0, size), ...chunk(arr.slice(size), size)] : [];

const safeScrollToId = (id) => {
    if (typeof document === "undefined") return;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const ServiceCard = ({ service: s }) => (
    <Card className="group h-full flex flex-col items-stretch hover:shadow-lg transition-all duration-500 bg-white/5 backdrop-blur-sm border border-white/20 shadow-lg hover:shadow-xl hover:translate-y-[-4px] relative overflow-hidden before:absolute before:inset-0 before:bg-gradient-to-br before:from-white/20 before:to-white/5 before:backdrop-blur-lg">
        <div className="absolute inset-0 bg-gradient-to-br from-white/15 to-transparent pointer-events-none" />
        <CardHeader className="relative z-10">
            <CardTitle className="font-serif text-olive-950">{s.title}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 relative z-10">
            <p className="text-olive-900/70 text-sm">{s.desc}</p>
            <div className="flex items-center justify-between">
                <span className="font-serif font-semibold text-olive-950">{s.price}</span>
                <Button
                    variant="ghost"
                    className="text-olive-700 hover:bg-olive-50/50 backdrop-blur-sm transition-all duration-300 hover:scale-105 border border-terracotta-200/50 rounded-2xl"
                    onClick={() => safeScrollToId("booking")}
                >
                    Записаться
                    <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
                </Button>
            </div>
        </CardContent>
    </Card>
);

export const ServicesSection = () => {
    return (
        <section id="services" className="pt-12 py-16 bg-olive-50 relative isolate">
            <div
                className="absolute right-0 overflow-hidden top-[10%] w-[40vw] ml-24 h-[30vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/bird.svg')" }}
            />
            <div
                className="absolute lleft-0 overflow-hidden top-[50%] w-[80vw] md:w-[40vw] ml-0 sm:ml-24 h-[40vh] bg-no-repeat bg-bottom bg-contain pointer-events-none"
                style={{ backgroundImage: "url('/image/svg/vetka.svg')" }}
            />
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h2 className="font-serif pt-12 text-3xl text-olive-950">
                    Услуги
                </h2>

                <p className="mt-2 text-olive-900/70 text-sm animate-in slide-in-from-top duration-1000 delay-300">
                    Выберите формат, который подходит вам сейчас.
                </p>

                {/* Mobile: carousel (3 cards per slide) */}
                <div className="mt-8 md:hidden">
                    <Carousel className="w-full">
                        <CarouselContent>
                            {chunk(SERVICES, 3).map((group, i) => (
                                <CarouselItem key={i}>
                                    <div className="space-y-4">
                                        {group.map((s) => (
                                            <ServiceCard key={s.id} service={s} />
                                        ))}
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <div className="flex items-center justify-center gap-4 mt-6">
                            <CarouselPrevious className="static translate-y-0" />
                            <CarouselNext className="static translate-y-0" />
                        </div>
                    </Carousel>
                </div>

                {/* Desktop: grid */}
                <div className="mt-8 hidden md:grid md:grid-cols-3 gap-6">
                    {SERVICES.map((s) => (
                        <ServiceCard key={s.id} service={s} />
                    ))}
                </div>
            </div>
        </section>
    );
};
